import { Exercise as ComponentExercise, ExerciseType, PronunciationPracticeData } from "@/services/admin/exercises.interfaces";
import { EditorInterface } from "./EditorInterface";
import { Mic } from "lucide-react";

/**
 * Editor para exercícios de prática de pronúncia (versão unificada)
 * Combina as funcionalidades de CardInfo para prática de pronúncia
 */
export class PronunciationPracticeInfo extends EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício de pronúncia
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): {
    title: string;
    subtitle: string;
    description?: string;
  } {
    if (!exercise || (exercise.type !== ExerciseType.PronunciationPractice && !PronunciationPracticeInfo.SupportsExerciseType(exercise.type as unknown as string))) {
      return {
        title: 'Prática de Pronúncia',
        subtitle: 'Sem detalhes',
      };
    }

    try {
      console.log("Dados do exercício recebido:", exercise);
      // Tenta extrair os dados do exercício, lidando com diferentes formatos
      let sentence = 'Sem frase para pronunciar';
      let duration = 'Sem limite';
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as PronunciationPracticeData;
        // Usar a primeira sentença do array sentences
        sentence = data.sentences && data.sentences.length > 0 
          ? data.sentences[0].replace(/^"|"$/g, '') 
          : 'Sem frase para pronunciar';
        duration = data.maxDuration ? `${data.maxDuration}s` : 'Sem limite';
      } 
      // Se os dados estiverem no formato plano (fallback para compatibilidade)
      else if ('sentence' in exercise) {
        sentence = (exercise as any).sentence || 'Sem frase para pronunciar';
        duration = (exercise as any).maxDuration ? `${(exercise as any).maxDuration}s` : 'Sem limite';
      }
      
      return {
        title: "Prática de Pronúncia",
        subtitle: sentence.length > 60 ? `${sentence.substring(0, 60)}...` : sentence,
        description: `Duração: ${duration}`,
      };
    } catch (error) {
      console.error("Erro ao processar dados do exercício de pronúncia:", error);
      return {
        title: 'Prática de Pronúncia',
        subtitle: 'Erro ao processar dados',
      };
    }
  }
  
  /**
   * Retorna o título do tipo de exercício de prática de pronúncia
   */
  static getTitle(): string {
    return "Prática de Pronúncia";
  }
  
  /**
   * Retorna uma descrição formatada para o exercício de prática de pronúncia
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    if (!exercise) {
      return "Sem detalhes";
    }
    
    try {
      // Tenta extrair os dados do exercício, lidando com diferentes formatos
      let duration = 'Sem limite';
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as PronunciationPracticeData;
        duration = data.maxDuration ? `${data.maxDuration}s` : 'Sem limite';
      } 
      // Se os dados estiverem no formato plano
      else if ('maxDuration' in exercise) {
        duration = (exercise as any).maxDuration ? `${(exercise as any).maxDuration}s` : 'Sem limite';
      }
      
      return `Duração: ${duration}`;
    } catch (error) {
      console.error("Erro ao processar dados do exercício:", error);
      return "Erro ao processar dados";
    }
  }
  
  /**
   * Retorna o ícone para exercícios de prática de pronúncia
   */
  static getIcon() {
    return Mic;
  }
  
  /**
   * Verifica se o exercício é do tipo de prática de pronúncia
   */
  static SupportsExerciseType(type: string): boolean {
    return type === ExerciseType.PronunciationPractice;
  }
}